module.exports = __webpack_public_path__ + "794fdb644430b318ed4a3bebf79e3db4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/icons/location.svg
// module id = 944
// module chunks = 0